<template>
  <div class="scheduleRulesClear">
    <el-dialog
      title="清除排班规则"
      :visible.sync="visible"
      width="350px"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content">
        <div class="tips">
          <div class="tips_row">清除排班规则会删除以下内容，请谨慎操作！</div>
          <div class="tips_row">1.删除所选日期及其之后的所有排班；</div>
          <div class="tips_row">2.删除周排班规则。</div>
        </div>
        <el-form ref="form" class="form" :model="form" :rules="rules" hide-required-asterisk>
          <div class="form_title">删除该日期及其之后的排班</div>
          <el-form-item prop="date">
            <el-date-picker
              class="form_date_picker"
              v-model="form.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :clearable="false"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'batchStop',
    data () {
      return {
        visible: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - (24 * 60 * 60 * 1000) || time.getTime() > Date.now() + (59 * 24 * 60 * 60 * 1000);
          }
        },
        rules: {
          date: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ]
        },
        form: {
          date: ''
        }
      }
    },
    methods: {
      open () {
        this.visible = true
      },
      close () {
        this.visible = false
        this.form.date = ''
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$emit('submit', JSON.parse(JSON.stringify(this.form)))
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .scheduleRulesClear /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .scheduleRulesClear /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .scheduleRulesClear /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .scheduleRulesClear /deep/ .el-dialog__body {
    padding: 0;
  }

  .scheduleRulesClear /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .content {
    padding: 16px;
  }

  .tips {
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    background-color: #FFF0E1;
    border-radius: 4px;
  }

  .tips_row {
    line-height: 20px;
    font-size: 14px;
    color: #FE8F1F;
  }

  .form {
    overflow: hidden;
  }

  .form_title {
    margin: 16px 0 0 0;
    line-height: 14px;
    font-size: 14px;
    color: #667182;
  }

  .form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #667182;
  }

  .form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_date_picker {
    margin: 12px 0 0 0;
    width: 100%;
  }
</style>